import { Link, useLocation } from "react-router-dom";

export default function Sidebar({ open }) {
  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path ||
    location.pathname.startsWith(path + "/")
      ? "bg-primary"
      : "";

  return (
    <div
      className="bg-dark text-white position-fixed top-0 start-0"
      style={{
        width: open ? 220 : 0,
        height: "100vh",
        transition: "width 0.3s ease",
        overflowX: "hidden",
        overflowY: "auto",
        zIndex: 1000,
      }}
    >
      {/* HEADER */}
      <div className="p-3 border-bottom text-center">
        <h5 className="m-0 fw-bold">Rinaldi Supplier</h5>
        <small className="text-secondary">Admin Panel</small>
      </div>

      {/* MENU */}
      <ul className="nav flex-column p-2 gap-1">

        {/* 🔥 DASHBOARD HOME */}
        <li className="nav-item">
          <Link
            className={`nav-link text-white rounded ${isActive("/dashboard")}`}
            to="/dashboard"
          >
            📊 Dashboard
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className={`nav-link text-white rounded ${isActive(
              "/dashboard/categories"
            )}`}
            to="/dashboard/categories"
          >
            📁 Kategori Produk
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className={`nav-link text-white rounded ${isActive(
              "/dashboard/products"
            )}`}
            to="/dashboard/products"
          >
            📦 Produk
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className={`nav-link text-white rounded ${isActive(
              "/dashboard/company-profile"
            )}`}
            to="/dashboard/company-profile"
          >
            🏢 Company Profile
          </Link>
        </li>
      </ul>
    </div>
  );
}
